import { useLottie } from 'lottie-react';
import animData from './data.json';
import { FC, useEffect } from 'react';

interface BionicLogoProps {
  className?: string;
  animate?: boolean;
}

const BionicLogo: FC<BionicLogoProps> = ({ className, animate = false }) => {
  const options = {
    animationData: animData,
    loop: true,
    autoplay: true,
  };

  const { View, play, pause } = useLottie(options, {});

  useEffect(() => {
    if (animate) play();
    else pause();
  }, [animate]);

  return (
    <div className={className} id="logo">
      {View}
    </div>
  );
};

export default BionicLogo;
